import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import { login, getUserInfo, logout } from '@/api/login';
import { selectPartyDetail, getBaseConfig } from '@/api/basic-setting/csCompany';
import { getToken, setToken, removeToken, remove401ConfirmTime } from '@/utils/auth';
import { STORAGE_KEY_PARTY_INFO, STORAGE_KEY_BASE_CONFIG } from '@/constants';
var user = {
  state: {
    token: getToken(),
    // 用户信息
    user: {},
    // 角色权限
    roles: [],
    // 甲方信息
    party: {},
    // 系统配置
    baseConfig: {},
    // 第一次加载菜单时用到
    loadMenus: false
  },
  mutations: {
    SET_TOKEN: function SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_USER: function SET_USER(state, user) {
      state.user = user;
    },
    SET_ROLES: function SET_ROLES(state, roles) {
      state.roles = roles;
    },
    SET_PARTY: function SET_PARTY(state, party) {
      state.party = party;
    },
    SET_BASE_CONFIG: function SET_BASE_CONFIG(state, data) {
      state.baseConfig = data;
    },
    SET_LOAD_MENUS: function SET_LOAD_MENUS(state, loadMenus) {
      state.loadMenus = loadMenus;
    }
  },
  actions: {
    /**
     * 登录
     *
     * @param commit
     * @param userInfo
     * @return {Promise<any>}
     */
    Login: function () {
      var _Login = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref, userInfo) {
        var commit, user, party, baseConfig;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              remove401ConfirmTime();
              _context.next = 4;
              return login(userInfo.username, userInfo.password, userInfo.code, userInfo.uuid, userInfo.source, userInfo.partyId);
            case 4:
              user = _context.sent;
              if (user) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return", Promise.reject());
            case 7:
              setToken(user.token, userInfo.rememberMe);
              commit('SET_TOKEN', user.token);
              setUserInfo(user.user, commit);
              // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
              commit('SET_LOAD_MENUS', true);
              _context.next = 13;
              return selectPartyDetail();
            case 13:
              party = _context.sent;
              _context.next = 16;
              return getBaseConfig();
            case 16:
              baseConfig = _context.sent;
              setPartyInfo(party, commit);
              setBaseConfig(baseConfig, commit);
              return _context.abrupt("return", Promise.resolve());
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function Login(_x, _x2) {
        return _Login.apply(this, arguments);
      }
      return Login;
    }(),
    /**
     * 获取用户所有信息
     *
     * @param dispatch
     * @param commit
     */
    GetInfo: function () {
      var _GetInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref2) {
        var dispatch, commit;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              dispatch = _ref2.dispatch, commit = _ref2.commit;
              _context2.next = 3;
              return dispatch('GetUserInfo');
            case 3:
              _context2.next = 5;
              return dispatch('GetPartyInfo');
            case 5:
              _context2.next = 7;
              return dispatch('GetBaseInfo');
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function GetInfo(_x3) {
        return _GetInfo.apply(this, arguments);
      }
      return GetInfo;
    }(),
    /**
     * 获取用户信息
     *
     * @param commit
     * @return {Promise<any>}
     */
    GetUserInfo: function GetUserInfo(_ref3) {
      var commit = _ref3.commit;
      return new Promise(function (resolve, reject) {
        getUserInfo().then(function (res) {
          setUserInfo(res, commit);
          resolve(res);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    /**
     * 获取甲方信息
     *
     * @param commit
     */
    GetPartyInfo: function GetPartyInfo(_ref4) {
      var commit = _ref4.commit;
      return new Promise(function (resolve) {
        selectPartyDetail().then(function (data) {
          setPartyInfo(data, commit);
          resolve(data);
        });
      });
    },
    /**
     * 获取系统配置
     *
     * @param commit
     */
    GetBaseInfo: function GetBaseInfo(_ref5) {
      var commit = _ref5.commit;
      return new Promise(function (resolve) {
        getBaseConfig().then(function (data) {
          setBaseConfig(data, commit);
          resolve(data);
        });
      });
    },
    /**
     * 登出
     *
     * @param commit
     * @return {Promise<any>}
     */
    LogOut: function LogOut(_ref6) {
      var commit = _ref6.commit;
      return new Promise(function (resolve, reject) {
        logout().then(function () {
          logOut(commit);
          resolve();
        }).catch(function (error) {
          logOut(commit);
          reject(error);
        });
      });
    },
    /**
     * 清空登录信息
     *
     * @param commit
     */
    RemoveLoginInfo: function RemoveLoginInfo(_ref7) {
      var commit = _ref7.commit;
      return new Promise(function (resolve) {
        logOut(commit);
        resolve();
      });
    },
    updateLoadMenus: function updateLoadMenus(_ref8) {
      var commit = _ref8.commit;
      return new Promise(function (resolve, reject) {
        commit('SET_LOAD_MENUS', false);
      });
    }
  }
};
export var logOut = function logOut(commit) {
  commit('SET_TOKEN', '');
  commit('SET_ROLES', []);
  removeToken();
  remove401ConfirmTime();
};
export var setUserInfo = function setUserInfo(res, commit) {
  // 如果没有任何权限，则赋予一个默认的权限，避免请求死循环
  if (res.roles.length === 0) {
    commit('SET_ROLES', ['ROLE_SYSTEM_DEFAULT']);
  } else {
    commit('SET_ROLES', res.roles);
  }
  commit('SET_USER', res);
};

/**
 * 保存party信息至 store 与 sessionStorage
 *
 * @param data
 * @param commit
 */
export var setPartyInfo = function setPartyInfo(data, commit) {
  commit('SET_PARTY', data);
  sessionStorage.setItem(STORAGE_KEY_PARTY_INFO, JSON.stringify(data));
};

/**
 * 保存系统配置至 store 与 sessionStorage
 *
 * @param data
 * @param commit
 */
export var setBaseConfig = function setBaseConfig(data, commit) {
  commit('SET_BASE_CONFIG', data);
  sessionStorage.setItem(STORAGE_KEY_BASE_CONFIG, JSON.stringify(data));
};
export default user;